import { render, staticRenderFns } from "./EmployerMatch.vue?vue&type=template&id=3610b2e4"
import script from "./EmployerMatch.vue?vue&type=script&lang=js"
export * from "./EmployerMatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports